import { render, staticRenderFns } from "./field-horizontal-table.vue?vue&type=template&id=904170a8&"
import script from "./field-horizontal-table.vue?vue&type=script&lang=js&"
export * from "./field-horizontal-table.vue?vue&type=script&lang=js&"
import style0 from "./field-horizontal-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports